'use strict';
import {module} from '../app';

module.directive('onEnter', ['$timeout', function ($timeout) {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          $timeout(function () {
            scope.$eval(attrs.onEnter);
          });

          event.preventDefault();
        }
      });
    };
  }]);



// WEBPACK FOOTER //
// ./src/scripts/directives/onEnter.js